import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAddNewBhajanMutation } from './bhajansApiSlice';
import { Spinner, Form } from 'react-bootstrap';

const NewBhajan = () => {
  const [formData, setFormData] = useState({
    title: '',
    author: '',
    content: '',
    tags: '',
    language: '',
    audio: null,
    coverImage: null,
    errors: {}
  });

  const [selectedAudio, setSelectedAudio] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const [addNewBhajan, { isLoading, isSuccess, isError, error }] = useAddNewBhajanMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSuccess) {
      navigate('/dashboard/bhajans');
    }
  }, [isSuccess, navigate]);

  const validate = () => {
    const errors = {};
    if (!formData.title.trim()) errors.title = 'Title is required';
    if (!formData.author.trim()) errors.author = 'Author is required';
    if (!formData.content.trim()) errors.content = 'Content is required';
    if (!formData.language.trim()) errors.language = 'Language is required';
    return errors;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      errors: { ...prev.errors, [name]: '' },
    }));
  };

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (type === 'audio') {
      setSelectedAudio(file);
      setFormData((prev) => ({ ...prev, audio: file }));
    } else if (type === 'coverImage') {
      setSelectedImage(file);
      setFormData((prev) => ({ ...prev, coverImage: file }));
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const errors = validate();
    if (Object.keys(errors).length > 0) {
      setFormData((prev) => ({ ...prev, errors }));
      return;
    }

    const payload = new FormData();
    payload.append('title', formData.title);
    payload.append('author', formData.author);
    payload.append('content', formData.content);
    payload.append('tags', formData.tags);
    payload.append('language', formData.language);

    if (selectedAudio) payload.append('audio', selectedAudio);
    if (selectedImage) payload.append('coverImage', selectedImage);

    try {
      await addNewBhajan(payload);
    } catch (err) {
      console.error("Bhajan creation failed:", err);
    }
  };

  const { title, author, content, tags, language, errors } = formData;
  const errClass = isError ? "errmsg" : "offscreen";

  return (
    <>
      <h2 className="pageHeading">Create Bhajan</h2>
      <p className={errClass}>{error?.data?.message}</p>

      <div className='formWrap'>
        <form onSubmit={handleFormSubmit}>

          <div className='formGroup'>
            <label>Title:</label>
            <input type='text' name='title' value={title} onChange={handleInputChange} placeholder='Enter Bhajan title' />
            {errors.title && <span className="error">{errors.title}</span>}
          </div>

          <div className='formGroup'>
            <label>Author:</label>
            <Form.Select name="author" value={author} onChange={handleInputChange}>
              <option value=''>Select Author</option>
              <option value="Dheer Singh धीर सिंह">Dheer Singh</option>
              <option value="Mangal Singh मंगल सिंह">Mangal Singh</option>
              <option value="Triloki Nath Bajpai त्रिलोकी नाथ बाजपेयी">Triloki Nath Bajpai</option>
            </Form.Select>
            {errors.author && <span className="error">{errors.author}</span>}
          </div>

          <div className='formGroup'>
            <label>Audio:</label>
            <input type='file' accept='audio/*' onChange={(e) => handleFileChange(e, 'audio')} />
          </div>

          <div className='formGroup'>
            <label>Cover Image:</label>
            <input type='file' accept='image/*' onChange={(e) => handleFileChange(e, 'coverImage')} />
          </div>

          <div className='formGroup'>
            <label>Tags:</label>
            <input type='text' name='tags' value={tags} onChange={handleInputChange} placeholder='e.g. भक्ति, ध्यान, आरती' />
          </div>

          <div className='formGroup'>
            <label>Language:</label>
            <Form.Select name="language" value={language} onChange={handleInputChange}>
              <option value=''>Select Language</option>
              <option value="Hindi">Hindi</option>
              <option value="Sanskrit">Sanskrit</option>
              <option value="English">English</option>
              <option value="Other">Other</option>
            </Form.Select>
            {errors.language && <span className="error">{errors.language}</span>}
          </div>

          <div className='formGroup'>
            <label>Content:</label>
            <textarea name='content' value={content} onChange={handleInputChange} placeholder='Enter Bhajan content' className='long-content' />
            {errors.content && <span className="error">{errors.content}</span>}
          </div>

          <div className='submit'>
            <button type='submit' className='btn btn-primary' disabled={isLoading}>
              {isLoading ? <Spinner size="sm" /> : 'Create Bhajan'}
            </button>
          </div>

        </form>
      </div>
    </>
  );
};

export default NewBhajan;
